import {gql} from '@apollo/client';

export const productFetchAll = gql`
  query ProductFetchAll {
    artworks {
        artworks {
            _id
            name
            status
        }
    }
  }
`;
